import React from "react";

import type { AttendeeAttrs } from "~/common/Attendees";
import Avatar from "~/ui/legacy/Avatar";
import { Modal } from "~/ui/legacyFellowIndex";

import styles from "~/lib/prose/nodes/keyResult/AttendeesWithoutAccessModal.module.css";

interface AttendeesWithoutAccessModal {
	attendeesWithoutAccess: Array<AttendeeAttrs>;
	onClose: () => void;
}

export default function AttendeesWithoutAccessModal({ attendeesWithoutAccess, onClose }: AttendeesWithoutAccessModal) {
	return (
		<Modal onClose={onClose} width="27.5rem">
			<Modal.Header onClose={onClose}>
				<Modal.Title>Attendees without access</Modal.Title>
			</Modal.Header>
			<Modal.Body className={styles.body}>
				<h6>{attendeesWithoutAccess.length} attendees without access</h6>
				{attendeesWithoutAccess.map(attendeeWithoutAccess => (
					<div key={attendeeWithoutAccess.id}>
						<Avatar user={attendeeWithoutAccess} link={false} width="2em" />
						<div className={styles.attendeeInfo}>
							<h4>{attendeeWithoutAccess.fullName}</h4>
							<p>{attendeeWithoutAccess.email}</p>
						</div>
					</div>
				))}
			</Modal.Body>
		</Modal>
	);
}
